// shadcn 標準の `cn` ヘルパ。clsx + tailwind-merge の薄いラッパ。
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
